// External library imports
import _ from 'lodash';
// Css module imports
import bidClasses from '../../Bidding.module.css';
import CustomTooltip from '../../../../../components/CustomToolTip/CustomTooltip';
import { getColumnWithSlotSize } from '../../../../../utils/biddingHelper';
import { momentTimeFormater } from '../../../../../utils/timeHelper';
import Typography from '../../../../../components/Typography/Typography';

const Capacity = ({ data }) => {
    const panicHours = _.get(data, ['panicHours'], []);
    const length = _.get(data, ['overall'], []).length || 24;
    const slots = Array.from({ length: length }, (__, i) => i);
    const columns = getColumnWithSlotSize(slots, 8);
    const bidDate = data.bidDate;
    return (
        <div className={`${bidClasses.InfoModalContainer}`}>
            <div>
                <div className={bidClasses.InfoModalHeading}>
                    <Typography content={'Overall Bid Capacity'} size={14} />
                </div>
                <div className={bidClasses.TableContainer}>
                    {columns.map((column, colIndex) => (
                        <table key={colIndex}>
                            <thead>
                                <tr>
                                    <th>Slot</th>
                                    <th>Hour</th>
                                    <th>Capacity</th>
                                </tr>
                            </thead>
                            <tbody>
                                {column.map((key) => (
                                    <tr key={key}>
                                        <td>{key + 1}</td>
                                        <td>
                                            {momentTimeFormater(bidDate).add(key, 'hour').hour()}-
                                            {momentTimeFormater(bidDate)
                                                .add(key + 1, 'hour')
                                                .hour()}
                                        </td>
                                        <td className={bidClasses.Flex} style={{ gap: '0.2vw' }}>
                                            {_.get(data, ['overall', key])}
                                            <CustomTooltip content={'Out of market'}>
                                                <span className="required">{panicHours.includes(`HOUR__${key}`) ? '*' : ''}</span>
                                            </CustomTooltip>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    ))}
                </div>
            </div>
            {_.get(data, 'primary', []).length ? (
                <div>
                    <div className={bidClasses.InfoModalHeading}>
                        <Typography content={'Primary Bid Capacity'} size={14} />
                    </div>

                    <div className={bidClasses.TableContainer}>
                        {columns.map((column, colIndex) => (
                            <table key={colIndex}>
                                <thead>
                                    <tr>
                                        <th>Slot</th>
                                        <th>Hour</th>
                                        <th>Capacity</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {column.map((key) => (
                                        <tr key={key}>
                                            <td>{key + 1}</td>
                                            <td>
                                                {momentTimeFormater(bidDate).add(key, 'hour').hour()}-
                                                {momentTimeFormater(bidDate)
                                                    .add(key + 1, 'hour')
                                                    .hour()}
                                            </td>
                                            <td>{_.get(data, ['primary', key])}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        ))}
                    </div>
                </div>
            ) : (
                ''
            )}
            {_.get(data, 'secondary', []).length ? (
                <div>
                    <div className={bidClasses.InfoModalHeading}>
                        <Typography content={'Secondary Bid Capacity'} size={14} />
                    </div>

                    <div className={bidClasses.TableContainer}>
                        {columns.map((column, colIndex) => (
                            <table key={colIndex}>
                                <thead>
                                    <tr>
                                        <th>Slot</th>
                                        <th>Hour</th>
                                        <th>Capacity</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {column.map((key) => (
                                        <tr key={key}>
                                            <td>{key + 1}</td>
                                            <td>
                                                {momentTimeFormater(bidDate).add(key, 'hour').hour()}-
                                                {momentTimeFormater(bidDate)
                                                    .add(key + 1, 'hour')
                                                    .hour()}
                                            </td>
                                            <td>{_.get(data, ['secondary', key])}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        ))}
                    </div>
                </div>
            ) : (
                ''
            )}
        </div>
    );
};

export default Capacity;
